module.exports = "<p>\n  mapping-field works!\n</p>\n"